import { ReactNode, PropsWithChildren } from 'react';

/**
 * ContentBody component for wrapping the content of the body (alerts and value).
 */
function ContentBody({ alerts, children }: PropsWithChildren<{ alerts?: ReactNode }>) {
  return (
    <div className="content-body">
      <div className="content-body-alerts">
        <div className="max-container">{alerts}</div>
      </div>
      <div className="content-body-value">
        <div className="max-container">{children}</div>
      </div>
    </div>
  );
}

export default ContentBody;
